// Fetches a CSRF token that matches the session right now. Pages restored by browser Back or from
// Turbo's snapshot cache keep the token they were rendered with, which is stale after a sign-in or
// session renewal; posting a stale token fails and Devise then signs the user out.
// Falls back to the page's meta token if the endpoint can't be reached.
export async function freshCsrfToken (fetchImpl = fetch) {
  const meta = document.querySelector('meta[name="csrf-token"]')

  try {
    const response = await fetchImpl('/csrf_token', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    })

    if (response.ok) {
      const data = await response.json()

      if (data?.token) {
        if (meta) meta.content = data.token

        return { token: data.token, signedIn: data.signed_in !== false }
      }
    }
  } catch (_error) {
    // Network hiccup: fall back to the token already in the page.
  }

  return { token: meta?.content, signedIn: true }
}

export function redirectToSignIn () {
  window.location.assign(`/sign_in?redir=${encodeURIComponent(window.location.pathname)}`)
}
